import { Box, Grid, styled } from '@ltvco/refresh-lib/theme';

export const PropertySearchFieldContainer = styled(Grid)(({ theme }) => ({
  height: '58px',
  display: 'flex',
  alignItems: 'center',
  border: `1px solid ${theme.palette.text.disabled}`,
  borderRadius: '32px',
  backgroundColor: theme.palette.background.paper,
  width: '100%',
  margin: theme.spacing(4, 0),

  '&:focus-within': {
    borderColor: theme.palette.primary.main,
  },

  '&.error': {
    borderColor: theme.palette.error.main,
  },

  [theme.breakpoints.down('sm')]: {
    margin: 0,
  },

  '& .error .MuiTypography-root': {
    left: '8px',

    [theme.breakpoints.down('sm')]: {
      left: '32px',
    },
  },
}));

export const PropertyFormContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(2),
}));

export const IntegratedSearchContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  width: '100%',
  alignItems: 'center',
  borderRadius: '32px',
  flexDirection: 'row',
  overflow: 'hidden',
  backgroundColor: theme.palette.common.white,
}));
